//学习中心
import introduction from '@/views/learning/introduction'
import marketing from '@/views/learning/marketing'
import detail from '@/views/learning/detail'
import experience from '@/views/learning/experience'
import operate from '@/views/learning/operate'
export default [
  {
    path: '/learning',
    name: 'learning',
    meta:[{name:'产品介绍'}],
    component: introduction
  },
  {
    path: '/learning/marketing',
    name: 'marketing',
    meta:[{name:'营销案例'}],
    component: marketing
  },
  {
    path: '/learning/detail',
    name: 'detail',
    meta:[{name:'文章详情'}],
    component: detail
  },
  {
    path: '/learning/experience',
    name: 'experience',
    meta:[{name:'经验学习'}],
    component: experience
  },
  {
    path: '/learning/operate',
    name: 'operate',
    meta:[{name:'系统操作'}],
    component: operate
  }
]


// WEBPACK FOOTER //
// ./src/router/learning.js